import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import InitConfirm from "../../components/divarInternalEstate/InitConfirm";
import Api from "../../tools/service";
import Swal from "sweetalert2";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import ProgressBar from "../../components/ProgressBar";
import {calculateOtpTimer, divarLinkGenerator, persianToEnglish, safeRedirect} from "../../tools/helpers";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../../components/modals/ErrorModal";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import requestOTP from "../../tools/api/divarInternalEstate/requestOTP";
import confirmOTP from "../../tools/api/divarInternalEstate/confirmOTP";
import OTP from "../../components/estateOriginality/OTP";
import useDivarAuth from "../../hooks/useDivarAuth";
import FinalCard from "../../components/divarInternalEstate/FinalCard";

const otpConfig = {
    title: 'کد اعتبار سنجی',
    length: 5,
}
const DivarInternalEstate = () => {
    const {token, platformUser, postToken, serviceType, returnUrl} = useDivarAuth();
    const navigate = useNavigate();
    const [components, setComponents] = useState(null)
    const [processInfo, setProcessInfo] = useState(null);
    const [pid, setPid] = useState(null)
    const mobile = platformUser ? platformUser.phone_number : null;
    const [isLoading, setLoading] = useState(true)
    const [otpConfirmLoading, setOtpConfirmLoading] = useState(false);
    const [otpRequestLoading, setRequestOtpLoading] = useState(false);
    const [otpError, setOtpError] = useState(null)
    const [otpDescription, setOtpDescription] = useState(null)
    const [otpActive, setOtpActive] = useState(false);
    const [otpTimer, setOtpTimer] = useState(null);
    const handleResetProcess = (canReset,newPid) => {
        setLoading(true)
        Api.put(REQUEST_URLS.DIVAR_INTERNAL_ESTATE.RESET, {
            pid: newPid,
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((response) => {
            if (!response.hasError) {

                handleGetProcess(newPid)

            } else {
                handleError({
                    message:response.message,
                    status:response.status,
                    callback:()=>{
                        Swal.fire({
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            text: response.message,
                            title: "ناموفق",
                            icon: 'error',
                            showCancelButton: false,
                            confirmButtonColor: '#d51e3e',
                            showConfirmButton: true,
                            confirmButtonText: 'تلاش مجدد',
                        }).then((result) => {
                            if(result.isConfirmed){
                                handleResetProcess(canReset,newPid)
                            }
                        })
                    }
                })
            }

        }).catch((e) => {

        }).finally(() => {

        })
    }
    const handleRedirect = ({status, price}) => {
        const link = divarLinkGenerator({
            returnUrl,
            price: price ? price : 0,
            status: status,

        },true);
        safeRedirect(link, () => {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: 'لینک معتبر نمی باشد.',
                showCancelButton: true,
                cancelButtonText: 'بستن',
                onCancel: () => {
                    Reoverlay.hideModal();
                    navigate('/404')

                }
            })
        })
    }
    const handleInquiryProcess = () => {
        const params = {
            post_token: postToken,
            service_type: serviceType
        }
        Api.get(REQUEST_URLS.DIVAR_INTERNAL_ESTATE.INQUIRY_PROCESS, {
            params,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((response) => {
            const {data, hasError, status, message} = response;
            if (!hasError) {
                if (!!data?.process && !!data?.process?.pid) {
                    handleGetProcess(data?.process?.pid);
                    setPid(data?.process?.pid)
                } else {
                    handleCreateProcess();

                }

            } else {
                setLoading(false);
                handleError({
                    message, status,callback: () => {
                        Swal.fire({
                            text: message,
                            title: "ناموفق",
                            icon: 'error',
                            backdrop: true,
                            focusConfirm: false,
                            showCancelButton: true,
                            cancelButtonColor: '#d51e3e',
                            confirmButtonColor: '#419e53',
                            confirmButtonText: 'تلاش مجدد',
                            cancelButtonText: 'بازگشت به دیوار',
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then((result) => {
                            if (result.isConfirmed) {


                            } else {
                                handleRedirect({
                                    status: "fail",
                                    price: "0"
                                })
                            }
                        })
                    }
                })
            }

        }).catch(e => {

        }).finally(() => {
        })
    }
    const handleCreateProcess = () => {
        //1
        setLoading(true);
        const data = {
            "platform_user_id": mobile,
            "post_token": postToken,
        };


        Api.post(REQUEST_URLS.DIVAR_INTERNAL_ESTATE.CREATE_PROCESS, data, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((response) => {
            const {data, message, status, hasError} = response;
            if (!hasError) {
                if (data) {
                    setPid(data.pid);
                    handleGetProcess(data.pid);
                }
            } else {
                handleError({
                    message, status, callback: () => {
                        Swal.fire({
                            text: message,
                            title: "ناموفق",
                            icon: 'error',
                            backdrop: true,
                            focusConfirm: false,
                            showCancelButton: status===845,
                            cancelButtonColor: '#d51e3e',
                            confirmButtonColor: '#419e53',
                            confirmButtonText: 'تلاش مجدد',
                            cancelButtonText: 'بازگشت به دیوار',
                            showConfirmButton:status!==845,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                if (status !== 845) {
                                    handleCreateProcess();
                                }

                            } else {
                                handleRedirect({
                                    status: "fail",
                                    price: "0"
                                })
                            }
                        })
                    }
                })
            }
        }).catch(() => {

        })
    }
    const handleGetProcess = (currentPid) => {
        setLoading(true);
        setOtpActive(false);
        Api.get(REQUEST_URLS.DIVAR_INTERNAL_ESTATE.FETCH_PROCESS, {
            params: {
                pid: (currentPid ? currentPid : pid)
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((response) => {
            const {data, hasError, status, message} = response;
            if (!hasError) {

                setComponents(data.components);
                setProcessInfo(data.process);

                if (data.process && data.components.current_component.name === 'Shahkar') {

                    handleShahkar(data.process.pid)
                    //when user Step is Shahkar automatic call Shahkar function
                } else if (data.process && data.components.current_component.name === 'EstateInquiry') {

                    handleEstateInquiry(data.process.pid)
                } else {
                    setLoading(false)
                }
                if (data?.components.current_component.name === 'Final') {
                    setPid(null)
                }
            } else {

                handleError({
                    message, status,callback: () => {
                        Swal.fire({
                            text: message,
                            title: "ناموفق",
                            icon: 'error',
                            backdrop: true,
                            focusConfirm: false,
                            showCancelButton: false,
                            cancelButtonColor: '#d51e3e',
                            confirmButtonText: 'تلاش مجدد',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                handleGetProcess();
                            }
                        })
                    }
                })
                setLoading(false)
            }
        }).catch((e) => {


        }).finally(() => {

        })

    }
    const handleShahkar = (newPid) => {
        setLoading(true)
        handleGenerateUuid('Shahkar', token).then(uuid => {
            setLoading(true);

            Api.post(REQUEST_URLS.DIVAR_INTERNAL_ESTATE.SHAHKAR, {
                pid: newPid,
                uuid: uuid,
            }).then((response) => {
                const {data, hasError, status, message} = response;
                if (!hasError) {
                    handleGetProcess(pid)
                } else {

                    handleError({
                        message,
                        status,
                        callback: () => {

                            Swal.fire({
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                text: message,
                                title: "ناموفق",
                                icon: 'error',
                                showCancelButton:false,
                                confirmButtonColor: '#d33',
                                confirmButtonText: data?.can_reset ? "ویرایش اطلاعات" : "تلاش مجدد",
                                showConfirmButton: true,
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    if (data?.can_reset) {
                                        handleResetProcess(data?.can_reset,newPid)
                                    } else {

                                        handleShahkar(newPid)
                                    }
                                }
                            });
                        }
                    })


                }

            }).catch(() => {

            }).finally(() => {

            })

        })
            .catch(error => {
                console.error(error);

            });

    }
    const [finalStatus, setFinalStatus] = useState(null);

    const handleEstateInquiry = (newPid) => {
        setLoading(true);
        handleGenerateUuid('EstateInquiry', token).then(uuid => {
            Api.post(REQUEST_URLS.DIVAR_INTERNAL_ESTATE.ESTATE_INQUIRY, {
                uuid: uuid,
                pid: newPid,
            }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then(response => {
                if (!response.hasError) {
                    handleGetProcess(newPid)
                } else {
                    handleError({
                        message: response.message, status: response.status, callback: () => {
                            Swal.fire({
                                text: response.message,
                                title: "ناموفق",
                                icon: 'error',
                                showCancelButton: false,
                                confirmButtonColor: '#d33',
                                confirmButtonText: response?.data?.can_reset ? "ویرایش اطلاعات" : "تلاش مجدد",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    if(response.data?.can_reset){
                                        handleResetProcess(response.data?.can_reset,newPid)
                                    }else {
                                        handleEstateInquiry(newPid)
                                    }

                                }
                            });
                        }
                    })
                }
            }).finally(() => {

            })
        })

    }
    const handleError = ({
                             message, status, callback = () => {
        }
                         }) => {
        if (status === -10) {

            setLoading(false)
            setFinalStatus({
                'status': 'fail',
                'message': message,
            })

        } else if (status === -11) {
            setLoading(false)
            setFinalStatus({
                'status': 'pending',
                'message': message,
            })

        } else if (status === -12) {
            setLoading(false)
            setFinalStatus({
                'status': 'success',
                'message': message,
            })
        } else if (status === -9) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'بازگشت به دیوار',
                confirmButtonTheme: "red",
                onConfirm: () => {
                    handleRedirect({
                        price: processInfo?.payment?.info?.init_amount,
                        status: 'fail',
                    });
                }
            })
        } else if (status === -20) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: false,
                showConfirmButton: false,
            })
        } else if (status === 403 || status === 401) {
            Swal.fire({
                text: message,
                title: "ناموفق",
                icon: 'error',
                backdrop: true,
                focusConfirm: false,
                showCancelButton: true,
                cancelButtonColor: '#d51e3e',
                cancelButtonText: 'بازگشت',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const id = sessionStorage.getItem('id');
                    navigate('/auth/gate/' + id + '/DivarInternalEstate?post_token=' + postToken)
                } else {
                    handleRedirect({status: 'fail', price: 0})
                }
            })
        } else if (status === 801 || status === 802 || status === -100 || status === 803 || status === 805) {
            Swal.fire({
                text: message,
                title: "ناموفق",
                icon: 'error',
                backdrop: true,
                focusConfirm: false,
                showCancelButton: false,
                confirmButtonColor: '#d51e3e',
                confirmButtonText: 'شروع مجدد',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.isConfirmed) {

                    handleCreateProcess()
                } else {

                }
            })

        } else {
            callback()
        }
    }

    useEffect(() => {

        if (!pid) {
            handleInquiryProcess();
        } else if (pid) {
            handleGetProcess();
        }

    }, []);
    const handleInitConfirm = (values) => {

        setLoading(true);
        handleGenerateUuid('EstateInquiry', token).then(uuid => {

            const data = {
                "uuid": uuid,
                "pid": pid,
                "Mobile": values.im_owner ? processInfo?.platform_user : persianToEnglish(values.mobile),
                "im_owner": values.im_owner,
                "i_have_access_to_owner": values.i_have_access_to_owner,
                "Basic": values.documentType === "Old" ? persianToEnglish(values.basic) : null,
                "Secondary": values.documentType === "Old" ? persianToEnglish(values.secondary) : null,
                "NationalId": persianToEnglish(values.nid),
                "UnitId": values.documentType === "Old" ? values.unitId : null,
                "DocumentType": values.documentType,
                "UniqueId": values.documentType !== "Old" ? persianToEnglish(values.uniqueId) : null,
                "OfficeNumber": values.documentType === "Old" ? persianToEnglish(values.officeNumber) : null,
                "PageNumber": values.documentType === "Old" ? persianToEnglish(values.pageNumber) : null
            };
            Api.put(REQUEST_URLS.DIVAR_INTERNAL_ESTATE.INIT_CONFIRM, data, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then(async response => {
                if (!response.hasError) {
                    if (response.data.otp_required) {
                        await handleRequestOTP();
                    } else {
                        handleGetProcess(pid)
                        setLoading(true);
                    }

                } else {
                    handleError({
                        message: response.message, status: response.status, callback: () => {
                            Swal.fire({
                                text: response.message,
                                title: "ناموفق",
                                icon: 'error',
                                backdrop: true,
                                focusConfirm: false,
                                showCancelButton: false,
                                confirmButtonColor: '#d51e3e',
                                confirmButtonText: 'شروع مجدد',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    handleCreateProcess()
                                }
                            })
                        }
                    })
                }
            })
        })


    }
    const handleRequestOTP = async () => {
        setRequestOtpLoading(true);
        setOtpError(null)
        const response = await requestOTP(token, {pid: processInfo.pid});
        setLoading(false);
        setRequestOtpLoading(false)
        if (response.hasError) {
            setOtpError(response.message);
        } else {
            const time = calculateOtpTimer(response.data.created_at, 120);
            setOtpTimer(time);
            setOtpActive(true)
            setOtpDescription(response.message)
        }
    }
    const handleConfirmOTP = async (value) => {
        setOtpConfirmLoading(true);
        setOtpError(null);
        const response = await confirmOTP(token, {pid: processInfo.pid, code: persianToEnglish(value)});
        setOtpConfirmLoading(false)
        if (response.hasError) {
            setOtpError(response.message);

        } else {

            handleGetProcess(processInfo.pid)
        }
    }
    if (isLoading) {
        return <ProgressBar theme="green" duration={30} type="Estate"/>
    }
    if(finalStatus){
        return <FinalCard finalData={finalStatus} handleRedirect={handleRedirect}/>
    }

    return <div>


        {processInfo && components.current_component.name === "InitConfirm" && !otpActive && <InitConfirm
            processInfo={processInfo}
            accessToken={token}
            handleConfirm={handleInitConfirm}
        />}
        {processInfo && components.current_component.name === "InitConfirm" && otpActive && otpTimer &&
            <div className="min-h-screen flex items-center justify-center">
                <OTP key={otpTimer} length={otpConfig.length}
                     title={otpConfig.title}
                     timerCount={otpTimer}
                     handleRequestOTP={handleRequestOTP}
                     confirmLoading={otpConfirmLoading}
                     retryLoading={otpRequestLoading}
                     handleConfirm={handleConfirmOTP}
                     error={otpError}
                     description={otpDescription}
                />
            </div>}
{/*

        {((processInfo && components.current_component.name === "Final") || isReported) && <div
            className="mt-3  w-11/12 md:w-6/12 lg:w-4/12 lg:max-w-md lg:mt-20  mx-auto  p-7 flex justify-center items-center flex-col  rounded-lg  shadow-sm bg-white ">
            {isReported ? <TbForbid className="text-5xl  text-red-500"/> :
                <TbShieldCheckFilled className="text-green-500 text-6xl "/>}
            <p className=" font-bold mt-2 mb-1  text-center">{warning ? "" : "اصالت ملک با موفقیت انجام شد."}</p>
            <p className=" text-sm mt-1 mb-3  text-center">{warning ? warning : "مشخصات ملک روی آگهی درج گردید."}</p>
            <div className=" grid w-full  gap-3">
                <div className=" grid w-full grid-cols-1 gap-3">
                    {<Button className="text-sm" theme={isReported ? "red" : "green"} rounded="rounded-lg"
                             onClick={() => {
                                 handleRedirect({
                                     price: processInfo?.payment?.info?.init_amount || 0,
                                     status: isReported ? 'fail' : 'success',
                                 });
                             }}>بازگشت به دیوار</Button>}

                </div>
            </div>
        </div>}*/}
    </div>
}
export default DivarInternalEstate;
